var map = {
	"./en/formatXML/i18nFormatXML": [
		"1ff0",
		"i18n-formatXML-en-formatXML-i18nFormatXML"
	],
	"./vi/formatXML/i18nFormatXML": [
		"290b",
		"i18n-formatXML-vi-formatXML-i18nFormatXML"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "c357";
module.exports = webpackAsyncContext;